/**
 * @author rmh
 * 功能：实体仓
 */

import { Service } from '@/tools'

export class PhysicalWarehouseService<T extends TStock.Warehouse> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TStock.Warehouse}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 模块说明：列表相关接口
   */
  warehousePage = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiPage', data)
  }

  /**
   * 模块说明：禁用/启用相关接口
   */
  updateStatus = <K extends T['ApiUpdateStatus']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiUpdateStatus', data)
  }

  /**
   * 模块说明：添加实体仓相关接口
   */
  addWarehouse = <K extends T['ApiAdd']>(data: K['req'], toast: string | undefined = '操作成功'): Promise<K['res']> => {
    return this.post2('v1/ApiAdd', data, toast)
  }

  /**
   * 模块说明：更新实体仓相关接口
   */
  updateWarehouse = <K extends T['ApiUpdate']>(data: K['req'], toast: string | undefined = '操作成功'): Promise<K['res']> => {
    return this.post2('v1/ApiUpdate', data, toast)
  }

  /**
   * 模块说明：查询实体仓下拉
   */
  dropDownList = <K extends T['ApiDropDownList']>(data?: K['req']): Promise<T['ApiDropDownList']['res']['data']> => {
    return this.post2('v1/ApiDropDownList', data)
  }

  /**
   * 模块说明：查询公司下负责人
   */
  getCompanyUserInfoList = (): Promise<T['ApiGetCompanyUserInfoList']['res']['data']> => {
    return this.post2('v1/ApiGetCompanyUserInfoList')
  }

  /**
   * 模块说明：批量获取公司下实体仓、业务仓信息
   * /api/stock/warehouse/v1/getBizWarehouseByWhIds
   */
  getBizWarehouseByWhIds = <K extends T['ApiGetBizWarehouseByWhIds']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiGetBizWarehouseByWhIds', data)
  }
  /**
   * 获取租户下实体仓列表及实体仓下业务仓列表
   * /api/stock/warehouse/v1/getWhBwhTreeByTenantId
   */
  getWhBwhTreeByTenantId = <K extends T['ApiGetWhBwhTreeByTenantId']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiGetWhBwhTreeByTenantId', data)
  }
  // 获取详情 /api/stock/warehouse/v1/detail

  detail = <K extends T['ApiDetail']>(data: K['req']): Promise<T['ApiDetail']['res']> => {
    return this.post2('v1/ApiDetail', data)
  }
}
